import { useState, useEffect, useCallback, useMemo } from 'react';
import { supabase } from './supabaseClient';
import { shopsForMap } from './shopUtils';

/**
 * Loads `public.shops` from Supabase (id, shop, location, description, photos, mapslink, …).
 */
export function useShopsFromDb() {
  const [rawRows, setRawRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    const { data, error: qErr } = await supabase
      .from('shops')
      .select('*')
      .order('id', { ascending: true });
    setLoading(false);
    if (qErr) {
      setError(qErr.message);
      setRawRows([]);
      return;
    }
    setRawRows(Array.isArray(data) ? data : []);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const shops = useMemo(() => shopsForMap(rawRows), [rawRows]);

  return { shops, rawRows, loading, error, reload: load };
}
